import { SizeProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FunctionComponent } from "react";
import { styled } from "@iventis/styles";

export const ResetPasswordIcon: FunctionComponent<{ size?: SizeProp }> = ({ size }) => (
    <>
        <FontAwesomeIcon size={size} icon={["fal", "rotate-right"]} />
        <StyledLockIcon size={size} icon={["fas", "lock-keyhole"]} />
    </>
);

const StyledLockIcon = styled(FontAwesomeIcon)`
    position: absolute;
    transform: scale(0.5);
`;
